<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <div class="user-clickable">
        <i class="fa fa-user" />
        <!-- <b-badge variant="danger" class="badge">{{ totalizadorCliente }}</b-badge> -->
      </div>
    </template>
    <template slot="dropdown">
      <!-- <b-dropdown-header tag="div" class="text-center">
        <strong>Novidades</strong>
      </b-dropdown-header>
      <b-dropdown-item disabled>
        <i class="fa fa-envelope-o"/> Atualizações
      </b-dropdown-item>
      <b-dropdown-item disabled>
        <i class="fa fa-bell-o"/> Notificações
      </b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center">
        <strong>Opções</strong>
      </b-dropdown-header>
      <b-dropdown-item>
        <i class="fa fa-user"/> Perfil
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-wrench"/> Opções
      </b-dropdown-item>
      <b-dropdown-item>
        <i class="fa fa-usd"/> Pagamentos
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center">
        <strong>Saída</strong>
      </b-dropdown-header>
      <b-dropdown-item>
        <i class="fa fa-shield"/> Bloquear
      </b-dropdown-item>-->
      <b-dropdown-item v-on:click="opcoes()">
        <i class="fa fa-cog" /> Opções
      </b-dropdown-item>
      <b-dropdown-item v-on:click="sair()">
        <i class="fa fa-lock" /> Sair
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<style>
.user-clickable {
  height: auto !important;
  margin: 0 30px !important;
  font-size: 30px;
}
.badge {
  font-size: 10px;
  margin-left: 10px !important;
}
.dropdown-item.active, .dropdown-item:active, .dropdown-item:active > i {
    color: #fff;
    text-decoration: none;
    background-color: #d82020 !important;
    font-weight: bold;
}
</style>


<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 42,
      atualizacoesCliente: 0,
      notificacoesCliente: 0,
      totalizadorCliente: 10,
      sair() {
        localStorage.clear();
        window.location.reload();
      },
      opcoes() {
        this.$router.push("/opcoes");
      }
    };
  }
};
</script>
